import { useRSimActivateMutation } from './useRSimActivateMutation.ts';
import { useRSimSuspendMutation } from './useRSimSuspendMutation.ts';
import { useRSimUnsuspendMutation } from './useRSimUnsuspendMutation.ts';
import { useRSimTerminateMutation } from './useRSimTerminateMutation.ts';
import { SIM_PRODUCT_ACTION, SimProductAction } from '../constants/simProductActions';
import { useRSimCancelLocationMutation } from './useRSimCancelLocationMutation.ts';
import { UseMutationOptions } from '@tanstack/react-query';

export const useRSimMakeAction = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  const { mutate: activateCards, isPending: activateCardsIsPending } =
    useRSimActivateMutation(options);

  const { mutate: suspendCards, isPending: suspendCardsIsPending } =
    useRSimSuspendMutation(options);

  const { mutate: unsuspendCards, isPending: unsuspendCardsIsPending } =
    useRSimUnsuspendMutation(options);

  const { mutate: terminateCards, isPending: terminateCardsIsPending } =
    useRSimTerminateMutation(options);

  const { mutate: cancelLocation, isPending: cancelLocationIsPending } =
    useRSimCancelLocationMutation(options);

  const makeAction = (action: SimProductAction, params: { euiccIds: string[] }) => {
    if (action === SIM_PRODUCT_ACTION.ACTIVATE) activateCards(params);
    else if (action === SIM_PRODUCT_ACTION.SUSPEND) suspendCards(params);
    else if (action === SIM_PRODUCT_ACTION.UNSUSPEND) unsuspendCards(params);
    else if (action === SIM_PRODUCT_ACTION.TERMINATE) terminateCards(params);
    else if (action === SIM_PRODUCT_ACTION.CANCEL_LOCATION) cancelLocation(params);
  };
  return {
    makeAction,
    isPending:
      activateCardsIsPending ||
      suspendCardsIsPending ||
      unsuspendCardsIsPending ||
      terminateCardsIsPending ||
      cancelLocationIsPending,
  };
};
